const vuetifyTheme = {
  primary: "#F58634",
  secondary: "#61696B",
  accent: "#ED3237"
};

const menu = [
  {
    path: "/produtos",
    name: "Produtos",
    icon: "fas fa-shopping-cart"
  },
  {
    path: "/lojas",
    name: "Lojas",
    icon: "fas fa-building"
  },
  {
    path: "/marcas-parceiras",
    name: "Marcas Parceiras",
    icon: "fas fa-tag"
  },
  {
    path: "/galeria",
    name: "Galeria",
    icon: "fas fa-images"
  },
  {
    path: "/contato",
    name: "Contato",
    icon: "fas fa-user"
  },
  {
    path: "/vagas",
    name: "Vagas",
    icon: "fas fa-clipboard-list"
  },
  {
    path: "/trabalhe-conosco",
    name: "Trabalhe Conosco",
    icon: "fas fa-briefcase"
  }
];

export { vuetifyTheme, menu };
